import { useCallback, useMemo } from 'react';

const filters = [
    {
        name: 'Type',
        fieldName: 'type',
        subFilters: [
            {
                filterValue: 'CUSTOM_AUDIENCE',
                filterName: 'Custom Audience',
            },
            {
                filterValue: 'SEARCH_KEYWORDS',
                filterName: 'Search Keywords',
            },
            {
                filterValue: 'MAIL_DOMAINS',
                filterName: 'Email Domains',
            },
            {
                filterValue: 'COMBINED_AUDIENCES',
                filterName: 'Combined',
            },
            {
                filterValue: 'FIRST_PARTY',
                filterName: 'First Party',
            },
            {
                filterValue: 'PIXEL_LOOKALIKE',
                filterName: 'Pixel Lookalike',
            },
            {
                filterValue: 'CRM_LOOKALIKE',
                filterName: 'CRM Lookalike',
            },
            {
                filterValue: 'PIXEL_BASED_PREDICTIVE',
                filterName: 'Pixel Predictive',
            },
            {
                filterValue: 'YAHOO_CRM_DEVICE',
                filterName: 'Y! Device ID',
            },
            {
                filterValue: 'YAHOO_CRM_MAIL',
                filterName: 'Y! Emails',
            },
            {
                filterValue: 'YAHOO_CRM_IP',
                filterName: 'Y! IP Address',
            },
            {
                filterValue: 'YAHOO_LAL',
                filterName: 'Y! Lookalike',
            },
            {
                filterValue: 'YAHOO_MAIL',
                filterName: 'Y! Mail Domains',
            },
            {
                filterValue: 'YAHOO_PIXEL',
                filterName: 'Y! Pixel',
            },
            {
                filterValue: 'YAHOO_PREDICTIVE',
                filterName: 'Y! Predictive',
            },
            {
                filterValue: 'YAHOO_PURCHASE',
                filterName: 'Y! Purchase Receipt',
            },
            {
                filterValue: 'YAHOO_RE_ENGAGMENT',
                filterName: 'Y! Engagement',
            },
            {
                filterValue: 'YAHOO_SEARCH',
                filterName: 'Y! Search Keywords',
            },
        ],
    },
];

export const useMyAudiencesFilters = myAudiences => {
    const filterRelevantSubFilters = useCallback((filters, myAudiences) => {
        const relevantTypes = myAudiences.map(segment => segment.type);
        return filters.map(filter => {
            if (filter.fieldName === 'type') {
                return {
                    ...filter,
                    subFilters: filter.subFilters.filter(subFilter => relevantTypes.includes(subFilter.filterValue)),
                };
            }
            return filter; // Return the filter as-is for non-Type filters
        });
    }, []);

    const filteredFilters = useMemo(
        () => filterRelevantSubFilters(filters, myAudiences),
        [filterRelevantSubFilters, myAudiences]
    );

    const filtersForInputSearch = useMemo(() => {
        const targetFilter = filteredFilters.find(filter => filter.name === 'Type');

        if (targetFilter) {
            return targetFilter.subFilters.reduce((map, subFilter) => {
                map[subFilter.filterName.toLowerCase()] = subFilter.filterValue;
                return map;
            }, {});
        }

        return {};
    }, [filteredFilters]);

    const getAudienceTypeMatchingInput = useCallback(
        input => {
            const inputStr = String(input);
            const matchedKey = Object.keys(filtersForInputSearch).find(key => key.includes(inputStr.toLowerCase()));
            return matchedKey ? filtersForInputSearch[matchedKey] : undefined;
        },
        [filtersForInputSearch]
    );

    return { filters: filteredFilters, getAudienceTypeMatchingInput };
};
